import { ReactNode } from "react";

import { FileIcon } from "@/assets/icons";

import { twMerge } from "tailwind-merge";

type EmptyDataProps = {
  icon?: ReactNode;
  description: string;
  className?: string;
  descriptionClassName?: string;
};

const EmptyData = ({
  icon,
  description,
  className,
  descriptionClassName
}: EmptyDataProps) => {
  return (
    <div className={twMerge("flex flex-col gap-3 p-6 items-center", className)}>
      {icon ?? <FileIcon className="fill-light-gray" />}
      <span
        className={twMerge(
          "text-[12px] text-grey font-sans",
          descriptionClassName
        )}
      >
        {description}
      </span>
    </div>
  );
};

export default EmptyData;
